import { DraftCloseActionSelectModal } from '../../../Draft'
import { QA_NAME_APPLICANT_DRAFT_CLOSE_ACTION_MODAL } from '../RentalPortalApplicants.constants'

function RentalPortalApplicantDraftCloseActionSelectModal(props) {
  return (
    <DraftCloseActionSelectModal
      {...props}
      cancelTextKey='Modal.CancelBtnKey'
      discardLabelKey='RentalPortal.ListingDraftCloseDiscardActionKey'
      formFieldsProps={{
        titleKey: 'RentalPortal.ListingDraftCloseActionTitleKey',
      }}
      qaName={QA_NAME_APPLICANT_DRAFT_CLOSE_ACTION_MODAL}
      saveLabelKey='RentalPortal.ListingDraftCloseSaveActionKey'
      submitTextKey='Modal.ContinueBtnKey'
      titleKey='RentalPortal.ListingDraftCloseModalTitleKey'
    />
  )
}

export default RentalPortalApplicantDraftCloseActionSelectModal
